<template>
    <div v-loading="mixinLoading">
        <Query ref="query" :page="pageName" @query-click="handleQueryClick" :list="allFilterList"/>
        <!-- 自定义列 -->
        <CustomizeModal 
        ref="refcustomizeModal" 
        :customList="assignObj" 
        :selectList="selectList" 
        :customBtnLoading="customBtnLoading"
        @getCustomList="getCustomList"/>
        <!-- 表格 -->
        <div class="com-table-view-apple">
            <div class="operation-box">
                <div class="operation-left">
                    <slot name="let-toolbar"></slot>
                </div>
                <div class="operation-right">
                    <el-button
                        icon="el-icon-s-operation"
                        size="mini"
                        @click="handleShowDefineRow">自定义列</el-button>
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        v-if="!isHasAuth('export')"
                        :loading="exportLoading"
                        @click="handleExport">导出</el-button>
                </div>
            </div>

            <div style="min-height: 200px;">
                <jt-table
                    border
                    :data="tableData"
                    style="width: 100%;"
                    ref="multipleTable"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    @sort-change="handlesortchange"
                    @header-dragend="handleDragEnd"
                    v-loading="!mixinLoading && loading"
                >
                    <!-- 默认 -->
                    <el-table-column
                        :prop="column.name"
                        :label="column.display_name"
                        :align="column.align"
                        :width="getLocalStorageWidth?.[pageName]?.[column.name] || column.width || null"
                        :fixed="column.fixed ? column.fixed : false"
                        :sortable="getsortable(column['field_type'], column.name)"
                            v-for="(column, index) in columns"
                        :key="index"
                        :render-header="(h, values)=>renderHeader(h, values, column)"
                        >
                        <template slot-scope="scope">
                            <div :class="{ lineheightmax: getshowTip(column.name) }" v-if="column.field_type=='1' && column.name=='org_name'"
                            class="text-color-primary pointer" @click="handleClickOrgName(scope.row)">
                                {{scope.row[column.name]}}
                            </div>


                            <div class="table_operate" v-else-if="column.name=='operate'">
                                <el-button type="text" @click="showDataModal(scope.row)" v-if="!isHasAuth('data')">数据</el-button>
                                <span v-else>-</span>
                            </div>
                            <div v-else-if="column.field_type=='2'">
                                <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                    <div class="column_name">
                                        {{ getcurrency(scope.row, column.name)['name'] }}
                                    </div>
                                    <div class="column_currency">
                                        {{ getcurrency(scope.row, column.name)['currency'] }}
                                    </div>

                                </div>
                                <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                            </div>
                            <div :class="{ lineheightmax: getshowTip(column.name) }" v-else> {{scope.row[column.name]}}</div>
                        </template>
                    </el-table-column>
                </jt-table>
            </div>

            <div class="component_pagination">
                <el-pagination
                    v-if="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pn"
                    :page-sizes="[30,50,100]"
                    :page-size="rn"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>
            <el-tooltip ref="cellTip" v-model="showPopper" placement="top-start" effect="dark">
                <div class="tip-apple-content" slot="content">{{tipContent}}</div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/marketManage/apple/index';
    import Query from "../components/query.vue";
    import CustomizeModal from '../modal/customizeModal';
    import { cloneDeep, debounce } from 'lodash';
    import {dataDetailModal} from '../modal/index';
    const other_Table_columns_no_sort = ['account_name_start_date'];
    import {setStorage, getStorage, removeStorage} from '@/utils/index.js';
    export default {
        name: "OrgIndex",
        props:{
            pageDimension:Array,
            pageFields:Array,
            pageFunc:Array,
            zone:String,
            rangeTime:Array,
            mixinLoading:Boolean,
            pageActionNames:Array,
        },
        components: {
            Query,
            CustomizeModal,
        },
        data() {
            return {
                pageName:'apple_promotion_manage_org',
                props_params: {}, //query 组件吐出参数 对象形式  (一般用在勾选操作与导出)
                pagination: true,
                pn: 1,
                rn: 30,
                totalCnt:0,
                selectList: [],
                customBtnLoading: false, //自定义列按钮loading
                columns: [
                    // {
                    //     "id": "1597",
                    //     "name": "org_name",
                    //     "display_name": "广告系列组",
                    //     "fixed": "",
                    //     "min_width": "300",
                    // }
                ],
                tableData:[],
                showPopper: false, //浮层提醒
                tipContent: '',    //浮层提醒内容
                show: false, //处理表格头显示后 显示表格
                loading: false, //处理表格loading
                cachaHeader: 1,
                exportLoading:false,
                getLocalStorageWidth:{}, //缓存宽度
            }
        },
        computed:{
            ...mapGetters(['tabs_map', 'apple_reload','apple_list_page_query']),
            allFilterList(){
                let dimensions = cloneDeep(this.pageDimension)||[];
                return dimensions.filter(item=>item.config).map(item=>{
                    item.config = JSON.parse(item.config);
                    return item;
                })
            },
            assignObj() {
                let chone_list = cloneDeep(this.pageDimension)
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_dime = chone_list.map(item=>{
                    item['meconfig'] = item['config'] && JSON.parse(item.config);
                    return item;
                })
                let res_pageFields = chone_list_pageFields.map(item=>{
                    // item.config = item['config'] && JSON.parse(item.config);
                    if(item['children']) {
                        item['children'].map(itemc => {
                            itemc['meconfig'] = itemc['config'] && JSON.parse(itemc['config']);
                            return itemc
                        })
                    }
                    return item;
                })
                let baselist = {
                    id : "b_1000",
                    name: 'base',
                    display_name: '基础信息',
                    children: res_dime
                }
                return [baselist,...res_pageFields]
            },
            isHasCampaignAction(){
                let tabsMap =  this.tabs_map||{};
                let apple =tabsMap.apple||[];
                return apple.map(item=>item.name).includes('apple_campaign');
            },
        },
        watch: {
            apple_reload: function(val) {
                this.getListBody(this.props_params)
            }
        },
        created(){
            this.getLocalStorageWidth = getStorage('localStorage','tableWidthMap') || {};
        },
        mounted() {
            this.getEventTip()
            this.getListHead((res)=>{
                const fields = res && res.map(item=>item['name'])
                this.props_params['fields'] = []
                this.props_params['fields'] = fields
            })
        },
        methods:{
            getcurrency(rows, name) {
                let name_currency = `${name}_currency`
                if(rows[name_currency]) {
                    return {
                        has: true,
                        name: rows[name],
                        currency: rows[name_currency],
                    }
                }else{
                    return {
                        has: false,
                        name: rows[name]
                    }
                }
            },
            // query 查询  isClear为true：表示点击的是【清空筛选】
            handleQueryClick(params,isClear) {
                console.log('params', params)
                this.$refs.query.setSubmitLoading(true);
                if(isClear){
                    this.$refs.query.setClearLoading(true);
                }

                let range_time = Array.isArray(this.rangeTime) && this.rangeTime.length != 0 ? `${this.rangeTime[0]}/${this.rangeTime[1]}` : ''
                this.pn = 1
                this.props_params = Object.assign(this.props_params,params,{range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn})
                // if(this.cachaHeader == 1) {
                //     this.getListHead((res)=>{
                //         const fields = res && res.map(item=>item['name'])
                //         this.props_params['fields'] = []
                //         this.props_params['fields'] = fields
                //         this.getListBody(this.props_params,isClear)
                //     })
                // }else{
                //     this.getListBody(this.props_params,isClear)
                // }
                this.getListBody(this.props_params,isClear)
            },
            // 判断是否显示tip事件
            getEventTip() {
                const _this = this;
                const cellTip = this.$refs.cellTip;
                const delay = 200;

                // 超长提示事件
                $(this.$el).on('mouseenter.tdcell', '.lineheightmax', debounce(function() {

                    const $cell = $(this);
                    if ($cell[0].offsetHeight === $cell[0].scrollHeight) {
                        return;
                    }

                    cellTip.referenceElm = $cell[0];
                    _this.showPopper = true;
                    _this.tipContent = $cell.text();
                }, delay))
                .on('mouseleave.tdcell', '.lineheightmax', function() {
                    if (!_this.showPopper) {
                        return;
                    }

                    _this.showPopper = false;
                    setTimeout(() => {
                        _this.showPopper = false;
                    }, delay);
                });
            },
            getshowTip(name) {
                // org_name 广告系列组 countries_or_regions 国家跟地区bloc_name 集团 company_name  客户
                const showTip = ['org_name','countries_or_regions', 'bloc_name', 'company_name']
                if(showTip.includes(name)) {
                    return true
                }else{
                    return false
                }
            },
            // 获取权限
            isHasAuth(name){
                let isauth = this.pageFunc.some(item => item['name'] == name)
                return !isauth
            },
            // 获取列表头
            getListHead(callback) {
                this.$refs.query.setSubmitLoading(false);
                this.loading = true
                this.columns.length = 0
                API.getCustomField({field_type: 'apple_promotion_manage_org'}).then(res => {
                    let resData = res.data
                    this.selectList = resData
                    const width140 = ['org_id', 'account_name_start_date', 'campaign_id']
                    const width110 = ['account_yy_type', 'yy_name', 'campaign_status', 'supply_source']
                    this.columns = resData.map(item=>{
                        item["display_name"] = item.label
                        item['align'] = 'left'
                        // 宽度特殊处理
                        if(item['field_type'] == 2) {
                            item['align'] = 'right'
                            let nums = item['display_name'].length
                            // item['width'] = ((nums * 12)) + 60
                            if(item.name == 'local_spend') {
                                item['width'] = 250
                            }else {
                                item['width'] = ((nums * 12)) + 60
                            }
                        }else{
                            if(width140.includes(item.name)) {
                                item['width'] = 120
                            }else if(width110.includes(item.name)){
                                item['width'] = 90
                            }else{
                                item['width'] = 190
                            }
                        }
                        return item
                    })
                    // this.show = true
                    this.cachaHeader = 2
                    callback && callback(resData)
                },err=>{
                    this.loading = false
                    this.$message.error(err.info)
                })
            },
            setListQueryData(params){
                let queryData = {
                    org_id:this.props_params.org_id||[],
                    org_name:this.props_params.org_name||[],
                    campaign_id:this.props_params.campaign_id||[],
                    campaign_name:this.props_params.campaign_name||[],
                    adgroup_id:this.props_params.adgroup_id||[],
                    adgroup_name:this.props_params.adgroup_name||[],
                };

                this.$store.commit('apple/SET_LIST_PAGE_QUERY',queryData);
                localStorage.setItem('AppleQueryRestoreData',JSON.stringify({
                    value:params,
                    tabName:this.$route.name,
                }));
            },
            //  获取列表体
            getListBody(params,isClear) {
                this.loading = true
                this.$refs.query.setSubmitLoading(true);
                if(isClear){
                    this.$refs.query.setClearLoading(true);
                }

                this.setListQueryData(params);
                API.getOrgList(params).then(res => {
                    this.loading = false
                    let resData = res.data
                    this.tableData = resData.list||[];
                    // this.pn = resData.pageNum
                    this.totalCnt = resData.totalCnt

                    this.$refs.query.setSubmitLoading(false);
                    if(isClear){
                        this.$refs.query.setClearLoading(false);
                    }

                    this.$nextTick(()=>{
                        this.$refs.multipleTable.doLayout()
                    })
                }, err=>{
                    this.loading = false
                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                            return          
                    }
                    this.$message.error(err.info)
                    this.$refs.query.setSubmitLoading(false);
                    if(isClear){
                        this.$refs.query.setClearLoading(false);
                    }

                })
            },
            // 自定义列
            handleShowDefineRow () {
                this.$refs.refcustomizeModal.showModal();
            },
            // 获取自定义列
            getCustomList(values) {
                console.log('values', values)
                this.customBtnLoading = true
                API.setCustomField({
                    field_type: 'apple_promotion_manage_org',
                    fields: values
                }).then(res => {
                    console.log('res', res)
                    this.customBtnLoading = false
                    this.$refs.refcustomizeModal.handleClose()
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    this.getListHead((res)=>{
                        const fields = res && res.map(item=>item['name'])
                        this.props_params['fields'] = []
                        this.props_params['fields'] = fields
                        
                        if(!fields.includes(this.props_params['order_by'])) {
                            this.props_params['order_by'] = ''
                            this.props_params['order_type'] = ''
                        }
                        this.getListBody(this.props_params)
                    })
                }, (err) => {
                    this.customBtnLoading = false
                    console.log('error', err);
                    this.$message.error(err.info)
                })
            },
            // 导出
            handleExport() {
                this.exportLoading = true;
                API.exportOrgList(this.props_params,{
                    timeout: 120 * 1000,
                }).then(res => {
                    this.exportLoading = false;
                    console.log('res', res)
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                }, (err) => {
                    this.exportLoading = false;
                    if(err.code =='403'){
                        this.$confirm(err.info, '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                            return          
                    }
                    this.$message.error(err.info||'请求异常');
                })
            },
            handleDragEnd(newWidth, oldWidth, column) {
                console.log('handleDragEnd',newWidth,oldWidth,column)
                let getCurrentNameWidth = this.getLocalStorageWidth[this.pageName] || {}
                //存储示例格式 {address: 707, date: 184, name: 246}
                let result = Object.assign(getCurrentNameWidth, {
                    [column.property]: parseInt(newWidth),
                });
                setStorage('localStorage', 'tableWidthMap', Object.assign({},this.getLocalStorageWidth,{
                    [this.pageName]: result
                }) );
            },
            // 排序
            handlesortchange({column, prop, order}) {
                console.log('handlesortchange',column, prop, order);
                //ascending 升   descending 降
                let order_type = order == 'ascending' ? 'asc' : (order=='descending'?'desc':'');
                this.props_params['order_by'] = order_type?prop:'';
                this.props_params['order_type'] = order_type
                this.getListBody(this.props_params)
            },
            // 排序显示
            getsortable(values, show) {
                if(values && values == 1 && other_Table_columns_no_sort.includes(show)) {
                    return 'custom'
                }
                return (values && values == 2) ? 'custom' : false
            },
            renderHeader(h, values, column) {
                let colName = column.name;
                let actionCol = this._findFieldByName(this.pageFields,colName)||{};
                let content_text = column['config'] && JSON.parse(column['config'])['title']
                let content_text1 = actionCol['config'] && JSON.parse(actionCol['config'])['title']
                // let content_width = '100px'
                // if(column['field_type'] == 2) {
                //     if(column['display_name'].length >= 8) {
                //         content_width = ((6 * 18)).toString()
                //     }
                // }
                let content_html = null
                if(column['field_type'] == 2) {
                    content_html = h(
                                    'el-tooltip',
                                        {
                                            props: {
                                            effect: 'dark',
                                            content: content_text1||content_text,
                                            placement: 'top',
                                            },
                                        },
                                        [
                                            h('i', {
                                            class: 'el-icon-question',
                                            style: 'margin-left:2px;'
                                            }),
                                        ]
                                    )
                }
                return h('div', {
                            style: 'display: inline-block;'
                        }, 
                [
                    h('div', {class: 'render-header-div'}, [
                        h('span', {
                                class: 'render-header-span'
                            }, values.column.label),
                        content_html
                    ])
                    
                ])
            },
            // 分页 切换条数
            handleSizeChange(val) {
                this.props_params.rn = val
                this.props_params.pn = 1
                this.rn = val
                this.pn = 1
                this.getListBody(this.props_params)
            },
            // 分页 选择页数
            handleCurrentChange(val) {
                this.props_params.pn = val
                this.pn = val
                this.getListBody(this.props_params)
            },
            handleClickOrgName(row){
                console.log('handleClickOrgName',row);
                if(this.isHasCampaignAction){
                    localStorage.removeItem('AppleQueryRestoreData');
                    this.$router.push({
                        name:'apple_campaign',
                        query:{
                            org_id:[row.org_id],
                            org_name:[row.org_name],
                        },
                        params:{
                            range:this.rangeTime,
                            zone:this.zone,
                        },
                    });
                }else{
                    this.$message.error('无广告系列页面权限，无法下钻跳转，若需请进行权限申请');
                }
            },
            getSearchList(isClear){
                if(!isClear){
                    this.props_params.range_time = this.rangeTime.join('/');
                    this.props_params.time_zone = this.zone;
                    this.getListBody(this.props_params);
                }else{
                    this.$refs.query.resetForm();
                }
            },
            showDataModal(row){
                dataDetailModal({
                    props:{
                        customClass:'modal-body-padding-top-10 modal-body-padding-bottom-10 modal-body-min-height-500',
                        data:{...row},
                        title:'广告系列组：'+row.org_name,
                        type:'org',   // org,campaign,adgroup,keyword,search_term
                        selectList:this.selectList,
                        pageFields:this.pageFields,
                        query:{
                            time_zone:this.zone,
                            range_time:this.rangeTime,
                        },
                    },
                    cbs:{
                    },
                })
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>
<style lang="scss">
    @import "~@/styles/apple_sd.scss";
</style>
<style lang="scss" scoped>
    .com-table-view-apple{
        background: #fff;
        /*padding: 10px 10px 10px;*/
        padding: 10px 0 10px;
        border-radius: 3px;
        border: 1px solid #e8eaec;
        margin-top: 10px;
        /*box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);*/
        .operation-box{
            display: flex;
            justify-content:space-between;
            align-items: center;
            margin-bottom: 10px;
            padding: 0 15px;
            .operation-left{
                display: flex;
                justify-content:flex-start;
                align-items: center;
            }
        }
        .component_pagination{
            padding-top: 20px;
            padding-right: 20px;
            text-align: right;
        }
    }
    .nodata{
        min-height: 300px;
    }
</style>


